import type { ListCardHeaderBadge } from '@/components/list-card-header'

/** Candidate “New” badge window from first publish time (matches product spec). */
export const JOB_CARD_NEW_BADGE_MS = 36 * 60 * 60 * 1000

function parsePublishedAtMs(raw: string | null | undefined): number | null {
  if (!raw?.trim()) return null
  const t = Date.parse(raw)
  return Number.isFinite(t) ? t : null
}

/**
 * Featured wins over New. Used when employer publication badges are hidden.
 */
export function candidateJobPromotionBadge(input: {
  isFeatured?: boolean | null
  publishedAt?: string | null
}): ListCardHeaderBadge | null {
  if (input.isFeatured) {
    return { label: 'Featured', variant: 'promotionSoft' }
  }
  const pubMs = parsePublishedAtMs(input.publishedAt)
  if (pubMs == null) return null
  if (Date.now() - pubMs <= JOB_CARD_NEW_BADGE_MS) {
    return { label: 'New', variant: 'secondarySoft' }
  }
  return null
}
